module.exports = __webpack_public_path__ + "interactiveApp/KurzByk/media/8 loupana plec (top blade vcelku).jpg";